import { lighten, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { ReactComponent as InfoIcon } from '../../static/_assets/info-icon-blue.svg';
import { ReactComponent as WarningIcon } from '../../static/_assets/warning-icon.svg';
import { TnTypography } from '../TnTypography';
export enum DisclaimerType {
  WARNING = 'warning',
  INFO = 'info',
}
export interface DisclaimerProps {
  disclaimerText: string;
  type?: DisclaimerType;
  hasBottomBorder?: boolean;
  hasBorder?: boolean;
}
export default function Disclaimer({
  disclaimerText,
  type = DisclaimerType.WARNING,
  hasBottomBorder = true,
  hasBorder = false,
}: DisclaimerProps) {
  const classes = useStyles({ hasBottomBorder, hasBorder });

  return (
    <div className={classes.helperTextContainer}>
      {type === DisclaimerType.WARNING ? (
        <WarningIcon className={classes.warningIcon} />
      ) : (
        <InfoIcon className={classes.infoIcon} />
      )}
      <TnTypography variant="caption2" className={classes.helperText}>
        {disclaimerText}
      </TnTypography>
    </div>
  );
}

const useStyles = makeStyles<Theme, { hasBottomBorder: boolean; hasBorder: boolean }>((theme: Theme) => ({
  helperTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    boxSizing: 'border-box',
    border: ({ hasBorder }) => (hasBorder ? `1px solid ${lighten('#000000', 0.8)}` : 'none'),
    borderRadius: ({ hasBorder }) => (hasBorder ? 4 : 0),
    borderBottom: ({ hasBottomBorder, hasBorder }) =>
      hasBorder || hasBottomBorder ? `1px solid ${lighten('#000000', 0.8)}` : 'none',
    padding: 16,
    marginBottom: ({ hasBottomBorder, hasBorder }) => (!hasBorder && hasBottomBorder ? 16 : 0),
  },
  helperText: {
    minWidth: 0,
    overflowWrap: 'break-word',
  },
  warningIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    display: 'block',
    fill: '#A50123',
    textAlign: 'center',
  },
  infoIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    display: 'block',
    fill: '#007BFF',
    textAlign: 'center',
  },
}));
